import isMobile from '../../plugins/is-mobile.js';
// import {TweenMax} from "gsap/TweenMax";
import ScrollMagic from "scrollmagic";
// import 'imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap';
import 'imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators.js';


var controller = new ScrollMagic.Controller();

var scene_hero = new ScrollMagic.Scene({
  triggerElement: "body",
  triggerHook: 'onEnter',
  // duration: 800,
  offset: 0
})
  // .addIndicators()
  .addTo(controller);

scene_hero.on('enter', () => {
  //triggerElementを過ぎたとき
});
scene_hero.on('leave', () => {
  //triggerElementを抜けたとき
});

if ($('.page-top').length) {

  var scene_first = new ScrollMagic.Scene({
    triggerElement: ".is-contents-first",
    triggerHook: 'onCenter',
    // duration: 200,
    offset: 0
  })
    // .addIndicators()
    .addTo(controller);

  scene_first.on('enter', () => {
    $('.is-contents-first').addClass('is-active');
  });

  var scene_first_thumbnail = new ScrollMagic.Scene({
    triggerElement: ".is-contents-first-thumbnail",
    triggerHook: 'onCenter',
    // duration: 200,
    offset: 0
  })
    // .addIndicators()
    .addTo(controller);

  scene_first_thumbnail.on('enter', () => {
    $('.is-contents-first-thumbnail').addClass('is-active');
  });

  var scene_first_detail = new ScrollMagic.Scene({
    triggerElement: ".is-contents-first-detail",
    triggerHook: 'onCenter',
    // duration: 200,
    offset: 0
  })
    // .addIndicators()
    .addTo(controller);

  scene_first_detail.on('enter', () => {
    $('.is-contents-first-detail').addClass('is-active');
  });

  var scene_second = new ScrollMagic.Scene({
    triggerElement: ".is-contents-second",
    triggerHook: 'onCenter',
    // duration: 200,
    offset: 0
  })
    // .addIndicators()
    .addTo(controller);

  scene_second.on('enter', () => {
    $('.is-contents-second').addClass('is-active');
  });

  var scene_second_thumbnail = new ScrollMagic.Scene({
    triggerElement: ".is-contents-second-thumbnail",
    triggerHook: 'onCenter',
    // duration: 200,
    offset: 0
  })
    // .addIndicators()
    .addTo(controller);

  scene_second_thumbnail.on('enter', () => {
    $('.is-contents-second-thumbnail').addClass('is-active');
  });

  var scene_second_detail = new ScrollMagic.Scene({
    triggerElement: ".is-contents-second-detail",
    triggerHook: 'onCenter',
    // duration: 200,
    offset: 0
  })
    // .addIndicators()
    .addTo(controller);

  scene_second_detail.on('enter', () => {
    $('.is-contents-second-detail').addClass('is-active');
  });

  // if (isMobile(768)) {
    // $('.top-recruit').addClass('is-sp');
    var top_recruit_first = new ScrollMagic.Scene({
      triggerElement: ".is-recruit-first",
      triggerHook: 'onCenter',
      // duration: 200,
      offset: -100
    })
      // .addIndicators()
      .addTo(controller);

    top_recruit_first.on('enter', () => {
      $('.is-recruit-first').addClass('is-active');
    });

    var top_recruit_second = new ScrollMagic.Scene({
      triggerElement: ".is-recruit-second",
      triggerHook: 'onCenter',
      // duration: 200,
      offset: -100
    })
      // .addIndicators()
      .addTo(controller);

    top_recruit_second.on('enter', () => {
      $('.is-recruit-second').addClass('is-active');
    });

    var top_recruit_third = new ScrollMagic.Scene({
      triggerElement: ".is-recruit-third",
      triggerHook: 'onCenter',
      // duration: 200,
      offset: -100
    })
      // .addIndicators()
      .addTo(controller);

    top_recruit_third.on('enter', () => {
      $('.is-recruit-third').addClass('is-active');
    });
  // } else {
    // $('.top-recruit').addClass('is-pc');
    var top_recruit = new ScrollMagic.Scene({
      triggerElement: ".top-recruit",
      triggerHook: 'onCenter',
      // duration: 200,
      offset: 0
    })
      // .addIndicators()
      .addTo(controller);
  
    top_recruit.on('enter', () => {
      $('.top-recruit').addClass('is-active');
    });
  // }
}

if ($('.l-end-image').length) {
  var end_image = new ScrollMagic.Scene({
    triggerElement: ".l-end-image",
    triggerHook: 'onEnter',
    // duration: 200,
    offset: 100
  })
    // .addIndicators()
    .addTo(controller);

  end_image.on('enter', () => {
    $('.l-end-image').addClass('is-active');
  });
}

if ($('.l-interview-links').length) {
  var end_image = new ScrollMagic.Scene({
    triggerElement: ".is-item-01",
    triggerHook: 'onEnter',
    // duration: 200,
    offset: 100
  })
    // .addIndicators()
    .addTo(controller);

  end_image.on('enter', () => {
    $('.is-item-01').addClass('is-active');
  });
}

